var React = require('react');

function IconBurger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"width":"18","height":"2","x":"3","y":"5","rx":"1","key":0}),React.createElement("rect",{"width":"18","height":"2","x":"3","y":"11","rx":"1","key":1}),React.createElement("rect",{"width":"18","height":"2","x":"3","y":"17","rx":"1","key":2})]));
}

IconBurger.defaultProps = {"id":"icon-burger","width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = IconBurger;

IconBurger.default = IconBurger;
